const buildNavigationOption = key => ({
  id: key,
  getPath: () => {
    return `/${key}`
  },
})

export const NAVIGATION_OPTION_IDS = {
  ALERT: buildNavigationOption("alert"),
  MAP: buildNavigationOption("map"),
  DASHBOARD: buildNavigationOption("dashboard"),
  ADMIN_DASHBOARD: buildNavigationOption("adminDashboard"),
  SCHOOL: buildNavigationOption("school"),
  WIRELESS_CONFIG: buildNavigationOption("wireless_config"),
  FILE_UPLOAD: buildNavigationOption("file_upload"),
  SPARK: buildNavigationOption("spark"),
}

/**
 * Get the initial route path based on user's system admin status.
 * System admins are directed to the school page, while regular users go to wireless config.
 *
 * @param {boolean} isSystemAdmin - Boolean indicating if the user is a system admin
 * @returns {string} The initial route path starting with "/"
 */
export const getInitialRoute = isSystemAdmin => {
  if (isSystemAdmin) {
    return NAVIGATION_OPTION_IDS.SCHOOL.getPath()
  }

  return NAVIGATION_OPTION_IDS.WIRELESS_CONFIG.getPath()
}

/**
 * @typedef {Object} Location
 * @property {string} pathname - The URL pathname
 */

/**
 * Extract the current navigation ID from the URL pathname.
 * Parses the pathname to get the first path component after the root.
 * If pathname is empty or root, returns the initial route for the user's role.
 *
 * @param {boolean} isSystemAdmin - Boolean indicating if the user is a system admin
 * @param {Location} location - The location object from React Router containing the pathname
 * @returns {string|null} The current navigation ID (first path component) or null if invalid
 */
export const getCurrentId = (isSystemAdmin, location) => {
  let { pathname } = location
  pathname = pathname.slice(1)

  if (!pathname.length) pathname = getInitialRoute(isSystemAdmin).slice(1)

  const components = pathname.split("/")
  if (!components.length) return null

  return components[0]
}
